import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ManufacturerDto } from '../../../../shared/dtos/manufacturer.dto';
import { ProgressData } from '../../../../shared/dtos/progress-data';
import { ResponseModel } from '../../../../shared/models/reponse.model';
import { ManufacturersService } from '../../../../shared/services/manufacturers.service';
import { ProgressIndicatingService } from '../../../../shared/services/progress-indicating.service';
import { PacData } from '../../../transfer-contract/dtos/pacData';
import { CancelContractDto } from '../../dtos/cancel-contract.dto';
import { CancelContractService } from '../../services/cancel-contract.service';

@Component({
    selector: 'app-cancel-contract',
    templateUrl: './cancel-contract.component.html',
    styleUrls: ['./cancel-contract.component.scss']
})
export class CancelContractComponent implements OnInit, OnDestroy {
    @ViewChild('cancelForm')public _cancelForm : any;

    public pac: string = '';
    public manufacturers: ManufacturerDto[];
    public selectedManufaturer: string|undefined;
    public cancelSpecificContract: boolean = false;
    public notes: string = '';
    public contractId: number|undefined|null;
    public hasError: boolean = false;
    public responseMessage: string = '';
    public cancelCheckBoxMandate: boolean = false;
    public cancelBtnEnable: boolean = false;
    public pacData = new PacData();

    private _unsubscribe$: Subject<void> = new Subject<void>();
    private _progress$: Subject<ProgressData> = new Subject<ProgressData>();

    public constructor(
        private manufacturersService: ManufacturersService,
        private cancelContractService: CancelContractService,
        private progressService: ProgressIndicatingService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {
    }

    public ngOnDestroy(): void {
        this._progress$.next();
        this._progress$.complete();
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }

    public ngOnInit(): void {
        this.progressService.show({
            initial: {
                done: false,
                header: 'Loading Manufacturer Details',
                details: 'Please wait...'
            },
            progress$: this._progress$
        });
        this.manufacturersService
            .getAllManufacturers()
            .pipe(
                map(res => res.manufacturerModel),
                takeUntil(this._unsubscribe$)
            )
            .subscribe(
                (response: ManufacturerDto[]) => {
                    this.manufacturers = response;
                    this.sendProgressDoneSignal();
                },
                () => {
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'error', summary: 'Fail', detail: 'Unable to load manufaturers.' });
                });
    }

    private sendProgressDoneSignal(): void {
        this._progress$.next({
            header: '',
            done: true
        });
    }

    public onCancelContractClicked(): void {
        this.confirmationService.confirm({
            header: 'Confirmation',
            message: 'Do you want to cancel this contract ?',
            accept: /* istanbul ignore next */ () => this.handleCancelContract()
        });
    }

    private handleCancelContract(): void {
        this.hasError = false;
        this.progressService.show({
            initial: {
                done: false,
                header: 'Canceling',
                details: 'Please wait...'
            },
            progress$: this._progress$
        });
        const data: CancelContractDto = {
            cancelAll: !this.cancelSpecificContract,
            contractId: this.contractId!,
            field1: this.notes,
            manufacturerName: this.selectedManufaturer!
        };
        this.cancelContractService
            .cancelContract(this.pacData.pac!, data)
            .pipe(takeUntil(this._unsubscribe$))
            .subscribe(
                () => {
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully cancelled this contract.' });
                    this.responseMessage = 'Successfully cancelled this contract.';
                    this.hasError = false;
                    this.notes = '';
                    this.cancelSpecificContract = false;
                    this.selectedManufaturer = undefined;
                    this.pac = '';
                    this.contractId = undefined;
                    this.clearFields();
                },
                (error) => {
                    const response = new ResponseModel(error.error);
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'error', summary: 'Fail', detail: response.message });
                    this.responseMessage = `Response code: ${response.responseCode} - ${response.message}`;
                    this.hasError = true;
                    // this.clearFields();
                });
    }

    public onContractIdChange(event: any): void {
        this.contractId = event.value;
        this.cancelCheckBoxMandate = false;
        this.cancelBtnEnable = false;
        if (this.contractId?.toString.length! > 0) {
            this.cancelCheckBoxMandate = true;
            this.cancelBtnEnable = true;
        }

        if (this.cancelCheckBoxMandate && this.cancelSpecificContract) {
            this.cancelBtnEnable = false;
        }
    }

    public onCheck(checked: boolean): void {
        this.cancelBtnEnable = false;
        if (this.cancelCheckBoxMandate && this.cancelSpecificContract) {
            this.cancelBtnEnable = false;
        } else if (!this.cancelSpecificContract && this.contractId?.toString.length! > 0) {
            this.cancelBtnEnable = true;
        }
        // else{
        //     this.cancelBtnEnable = false;
        // }
    }

    private clearFields() : void {
        this.pacData.pac = '';
        this.selectedManufaturer = '';
        this.contractId = null;
        this.notes = '';
        if (this._cancelForm.valid) {
            this._cancelForm.reset();
        }
    }
}
